(function() {
  const cartDrawer = document.querySelector('.LOP-cart-drawer');
  if (!cartDrawer) return;

  const initRecommendedProductsNav = () => {
    const recommendedSection = cartDrawer.querySelector('.LOP-cart-drawer--recommended-products');
    if (!recommendedSection) return;

    const nav = recommendedSection.querySelector('.LOP-cart-drawer--recommended-products-nav');
    const carousel = recommendedSection.querySelector('.LOP-cart-drawer--recommended-products-carousel');
    const viewport = carousel?.querySelector('.theme-scroll--inner');
    const prevBtn = nav?.querySelector('.flickity-prev');
    const nextBtn = nav?.querySelector('.flickity-next');

    if (!viewport || !prevBtn || !nextBtn) return;

    const slides = carousel.querySelectorAll('.carousel__slide');
    if (slides.length < 2) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    let slideWidth = 0;
    const updateSlideWidth = () => {
      if (slides.length > 1) {
        slideWidth = slides[1].offsetLeft - slides[0].offsetLeft;
      } else if (slides[0]) {
        slideWidth = slides[0].offsetWidth;
      }
    };

    const updateButtons = () => {
      const scrollLeft = viewport.scrollLeft;
      const scrollWidth = viewport.scrollWidth;
      const clientWidth = viewport.clientWidth;
      const reachedEnd = scrollWidth - clientWidth <= Math.floor(scrollLeft) + 1;

      prevBtn.disabled = scrollLeft === 0;
      nextBtn.disabled = reachedEnd;
    };

    const scroll = (direction) => {
      updateSlideWidth();
      const scrollAmount = slideWidth || viewport.clientWidth * 0.8;
      const currentScroll = viewport.scrollLeft;
      const newScroll = direction === 'next' 
        ? currentScroll + scrollAmount 
        : currentScroll - scrollAmount;

      viewport.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    };

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      scroll('prev');
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      scroll('next');
    });

    const debouncedUpdateButtons = (() => {
      let timeout;
      return () => {
        clearTimeout(timeout);
        timeout = setTimeout(updateButtons, 100);
      };
    })();

    viewport.addEventListener('scroll', debouncedUpdateButtons);
    
    // Inicializar estado de botones
    updateSlideWidth();
    updateButtons();

    // Observar cambios de tamaño
    if (window.ResizeObserver && slides[0]) {
      const resizeObserver = new ResizeObserver(() => {
        updateSlideWidth();
        updateButtons();
      });
      resizeObserver.observe(slides[0]);
    }
  };

  // Inicializar cuando el carrito se abre o cuando el DOM está listo
  const observer = new MutationObserver((mutations) => {
    const isOpen = !cartDrawer.hasAttribute('inert');
    if (isOpen) {
      setTimeout(initRecommendedProductsNav, 100);
    }
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['inert']
  });

  // Inicializar si el carrito ya está abierto
  if (!cartDrawer.hasAttribute('inert')) {
    setTimeout(initRecommendedProductsNav, 100);
  }
})();
